module.exports = __webpack_public_path__ + "img/COVID19.779702fa.png";